import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const registerAction = (tmpl:any): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          return `<${tagName} wmFormAction [class]="'widget-overlay-parent-position'"  name="${attrs.get('name') || attrs.get('key')}" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
}

register('wm-form-action', registerAction.bind(this, ''));
register('wm-filter-action', registerAction.bind(this, ` update-mode="true" `));

export default () => {};
